import { useEffect, useState } from "react";
import { auth, db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

export const useWeddingData = (slug = null) => {
  const [weddingData, setWeddingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        // PUBLIC MODE: fetch by slug from "sites"
        if (slug) {
          const siteRef = doc(db, "sites", slug);
          const siteSnap = await getDoc(siteRef);

          if (siteSnap.exists()) {
            setWeddingData(siteSnap.data());
          } else {
            setWeddingData(null);
          }

          return;
        }

        // ADMIN MODE: fetch logged-in user's data from "users"
        const user = auth.currentUser;

        if (!user) {
          setWeddingData(null);
          return;
        }

        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          setWeddingData(userSnap.data());
        } else {
          setWeddingData(null);
        }
      } catch (error) {
        console.error("Error fetching wedding data:", error);
        setWeddingData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  return { weddingData, loading };
};